module.exports = __webpack_public_path__ + "static/media/checkstyle02.37254a81.png";